import { render, staticRenderFns } from "./ManagementEditFacility.vue?vue&type=template&id=20f65a60"
import script from "./ManagementEditFacility.vue?vue&type=script&lang=js"
export * from "./ManagementEditFacility.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports